import { useRouter } from 'next/router';

import { ViewResolverComponent } from '@/components/view-resolver';
import { useCommonContextProps } from '@/hooks';
import { isPharmaprixBanner, getBannerHostUrl } from '@/utils';
import { useMainContentWithGrid } from '@/utils/data-manipulation-utils';
import { trackProductSearch, getProductSearchRedirectContext } from '@/utils/analytics/analytics-utils';

export default function CommonComponent({
  viewDefinition,
  themeTokens,
  pageId,
  headerSection,
}: {
  viewDefinition: any;
  themeTokens: any;
  pageId: any;
  headerSection: object | null | undefined;
}) {
  const {
    commonContextProps: {
      settings: { banner },
    },
    cartCount,
    locale,
    currentDevice,
    pcOptimumAccount,
  } = useCommonContextProps();
  const router = useRouter();
  const updatedView = useMainContentWithGrid(viewDefinition);

  const searchRedirectData = viewDefinition?.searchRedirectData || {};
  if (searchRedirectData.isRedirectEnabled) {
    const hostNameUrl = getBannerHostUrl();
    const { phxRedirectUrl, sdmRedirectUrl } = searchRedirectData;
    const redirectUrl = isPharmaprixBanner() ? phxRedirectUrl : sdmRedirectUrl;
    const searchTerm = searchRedirectData?.searchTerm;
    // Track search redirect
    const searchRedirectContext = getProductSearchRedirectContext(searchRedirectData, viewDefinition);
    const globalContextFields = {
      cartCount,
      locale,
      currentDevice,
      pageId,
      pcOptimumAccount,
    };
    trackProductSearch(searchRedirectContext, globalContextFields);

    if (redirectUrl.startsWith('http://') || redirectUrl.startsWith('https://')) {
      const targetUrl = new URL(redirectUrl);
      if (searchTerm) {
        targetUrl.searchParams.append('originalTarget', searchTerm);
      }
      router.push(targetUrl);
    } else {
      const formattedRedirectUrl =
        redirectUrl.substring(0, redirectUrl.indexOf('/c/')).toLowerCase() +
        redirectUrl.substring(redirectUrl.indexOf('/c/'));
      const targetUrl = new URL(`${hostNameUrl}${formattedRedirectUrl}`);
      if (searchTerm) {
        targetUrl.searchParams.append('originalTarget', searchTerm);
      }
      router.push(targetUrl);
    }

    return null;
  }

  return (
    <div data-testid="main-page">
      <ViewResolverComponent
        headerSection={headerSection}
        pageId={pageId}
        initialData={updatedView}
        themeTokens={themeTokens}
        seo={{
          banner,
          appTitle: 'Loblaw Digital',
          currentUrlBase: getBannerHostUrl(),
        }}
      />
    </div>
  );
}
